import immutableUpdate from 'react-addons-update';
import * as _ from '../lodash';

import { SET_PRODUCT } from '../actions/products';

const initialState = {
  data: {},
  maxAvailability: 0,
};

/**
 * map productData from array of string to array of object for an easier way to get capacity, variant based on selected variant.
 *
 * for exp:
 *
 * { ['S', 'PURPLE'], capacity: 6 } ==> [
 *  {S: {
 *      PURPLE: {
 *        capacity: 6,
 *      }
 *    }
 * ];
 * @param {Object} productData
 */
function mapToAppState(productData) {
  const variantResult = {};


  productData.variants.forEach((data) => {
    _.set(variantResult, data.options.join('.'), {
      unitMultiplier: data.unit_multiplier,
      capacity: data.capacity,
      duration: data.duration,
      duration_range: data.duration_range,
      external_id: data.external_id,
      id: data.id,
      price: data.price,
      title: data.title,
    });
  });

  const capacity = {
    type: productData.capacity.type,
    capacities: productData.capacity.capacity,
  };

  if (capacity.type === 'variant_option') {
    capacity.options = productData.capacity.options;
    capacity.capacities = productData.capacity.capacities.reduce((obj, data) => _.set(obj, data.values.join('.'), { capacity: data.capacity }), {});
  } else if (capacity.type === 'resource') {
    capacity.options = productData.capacity.resources.map(({ name }) => name);
    capacity.capacities = productData.capacity.resources.reduce((obj, item) => ({ ...obj, [item.name]: item }), {});
  }

  return {
    ...productData,
    capacity,
    variants: variantResult,
  };
}

export default function productReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PRODUCT: {
      let maxAvailability = 0;
      switch (action.value.capacity.type) {
        case 0: {
          maxAvailability = action.value.capacity.quantity;
          break;
        }
        case 1: {
          maxAvailability = _.sumBy(action.value.variants, 'capacity');
          break;
        }
        case 2: {
          maxAvailability = action.value.capacity.quantity;
          break;
        }
        default:
          break;
      }
      return immutableUpdate(state, {
        data: { $set: action.value.profile === 'product' ? mapToAppState(action.value) : action.value },
        maxAvailability: { $set: maxAvailability },
      });
    }
    default:
      return state;
  }
}
